import React from 'react';
import { isConsultancy } from '../../../../../common/components/ProjectStatus/utils';

function ViewHeader(props) {
  const { project } = props;
  const headerText =
    project && isConsultancy(project.plan)
      ? 'Your design brief'
      : 'Stage 2 customer brief - additional questions to complete';
  return (
    <div className="onboarding-header_title-wrapper">
      <h2 className="onboarding-header_title">{headerText}</h2>
    </div>
  );
}

function EditHeader(props) {
  return (
    <div className="onboarding-header_title-wrapper">
      <div className="onboarding-header_edit-title-wrapper">
        <input
          className="form-control onboarding-header_edit-title-input"
          size="40"
          type="text"
          onChange={props.onChange}
          onKeyPress={props.onEnterKey}
          value={props.project.name}
        />
        <button className="btn onboarding-header_edit-title-submit" onClick={props.onClick}>
          ok
        </button>
      </div>
    </div>
  );
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEdit: false };
    this.changeToEdit = this.changeToEdit.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onEnterKey = this.onEnterKey.bind(this);
  }

  changeToEdit(e) {
    e.preventDefault();
    this.setState({ isEdit: true });
  }

  onClick() {
    this.setState({ isEdit: false });
  }

  onChange(e) {
    this.props.updateProject({ name: e.target.value });
  }

  onEnterKey(e) {
    if (e.key == 'Enter') {
      this.onClick();
    }
  }

  render() {
    return (
      <div>
        {this.state.isEdit ? (
          <EditHeader
            project={this.props.project}
            onClick={this.onClick}
            onChange={this.onChange}
            onEnterKey={this.onEnterKey}
          />
        ) : (
          <ViewHeader project={this.props.project} />
        )}
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Header.js